module.exports = __webpack_public_path__ + "static/media/xtra-black.75c18fa9.jpg";